import { createSelector } from '@reduxjs/toolkit';
import { ActiveACLs } from 'console/shared/device.acl/utils';
import { selectNullableSelectedDeviceId, selectSelectedDevice, selectSelectedDeviceFields, } from 'entities/device/lib';
import { ACLGroupId } from 'shared/device.acl/model/type';
export const select_acls = createSelector((state) => selectSelectedDevice(state)?.access, selectNullableSelectedDeviceId, (state) => state?.access_suggestions?.out, (access, device_id, sug_out) => [
    ...ActiveACLs(access ?? []),
    ...(sug_out ?? [])
        .filter((sug) => sug.device_id === device_id)
        .map((sug) => sug.acl_item),
]);
export const selectSelectedDeviceHavePermission = createSelector(selectSelectedDeviceFields([
    'access',
    'user_id',
    'denied_access_group_ids',
]), (state) => state.account.id, (state) => state.account.real_account?.id, (state) => !!state.account.real_account?.is_staff, (state) => !!state.account.real_account?.is_superuser, (state) => state.account.can_staff_edit_devices_without_permission, (dev, user_id, real_user_id, is_staff, is_superuser, have_permission) => {
    if (dev == null) {
        return true;
    }
    if (is_superuser) {
        return true;
    }
    if (real_user_id) {
        //Сам под собой зашёл
        if (user_id == real_user_id) {
            // Если владелец устройства
            if (user_id == dev?.user_id) {
                return true;
            }
            if (dev.access?.some(({ user_id: acl_user_id }) => acl_user_id && acl_user_id === user_id)) {
                return true;
            }
        }
    }
    if (is_staff) {
        if (have_permission &&
            !dev.denied_access_group_ids?.includes(ACLGroupId.support)) {
            return true;
        }
        return !!dev.access?.some(({ group_id }) => group_id === ACLGroupId.support);
    }
    return !!dev.access?.some(({ user_id: acl_user_id }) => acl_user_id && acl_user_id === user_id);
});
